export enum DepositStatus {
  Lavorazione = 'Lavorazione',
  Verificata = 'Verificata',
  Chiusa = 'Chiusa',
}

export interface DepositSearchObject {
  dataDa?: string | null;
  dataA?: string | null;
  statiDistinta: DepositStatus[];
}

export interface DepositSearch {
  searchObject: DepositSearchObject;
}

export interface Deposit {
  id?: string | null;
  numeroDistintaVersamenti: number;
  data: string;
  stato: DepositStatus;
  totaleVersamento?: number | null;
}

export interface DepositList {
  items: Deposit[];
  totalItems: number;
}

export interface CashDenomination {
  taglio: number;
  quantita: number;
  importo: number;
}

export interface DepositCashPayment {
  numeroIncasso?: number | null;
  dataIncasso?: string | null;
  totaleMonete?: number | null;
  totaleBanconote?: number | null;
  totale?: number | null;
  tagli: CashDenomination[];
}

export interface DepositCheck {
  id: string;
  numeroAssegno: string;
  importo: number;
  dataIncasso: string;
  nomeBanca: string;
  abi: string;
  cab: string;
  numeroIncasso: number;
  flagAssegnoVerificato: boolean;
}

export interface DepositAttachment {
  id: string;
  nomeFile?: string | null;
  contentType?: string | null;
  dataUpload?: string | null;
}

export interface DepositDetail {
  id?: string | null;
  numeroDistintaVersamenti: number;
  stato: DepositStatus;
  data?: string | null;
  totaleValuta?: number | null;
  totaleAssegni?: number | null;
  totaleVersamento?: number | null;
  versamentiContante: DepositCashPayment[];
  assegniDaVerificare: DepositCheck[];
  codBanca?: string | null;
  denominazioneBanca?: string | null;
  numeroOperazione?: string | null;
  dataOperazione?: string | null;
  esitoUltimoTentativoChiusura?: string | null;
  allegati: DepositAttachment[];
}

export interface CreateDepositResponse {
  idDistinta: string | null;
}

export interface CloseDepositPayload {
  codBanca: string;
  numeroOperazione: string;
  dataOperazione: string;
}

export interface UiOption {
  value: string;
  label: string;
}
